const HEADER_OFFSET = 56;

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function scrollToSection(
  sectionId: string,
  options?: { offset?: number; behavior?: ScrollBehavior }
): void {
  const element = document.getElementById(sectionId);
  if (!element) return;

  const offset = options?.offset ?? HEADER_OFFSET;
  const behavior =
    options?.behavior ?? (prefersReducedMotion() ? "auto" : "smooth");

  const top = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top, behavior });
}

export function scrollToLegacyHash(hash: string): void {
  const id = hash.replace("#", "");
  if (id) scrollToSection(id);
}
